import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { checkForErrors } from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';

export const loadBots = async (
  ctx: ProStudioContext,
  _event: ProStudioEvents
): Promise<{
  solutions: ProStudioContext['solutions'];
}> => {
  const { project } = ctx;

  const projectProStudioSettingId = project?.projectProStudioSetting?.id;

  if (!projectProStudioSettingId) {
    throwErrorWithId('Project Pro Studio Setting ID is required');
    return { solutions: [] };
  }

  const solutionsResponse = await urqlGql.getSolutions({
    projectProStudioSettingId,
  });

  checkForErrors(solutionsResponse);

  return {
    solutions: solutionsResponse.data?.admin_?.solutions,
  };
};
